import React, { useEffect, useState } from 'react'
import ListComponent from '../../genericComponents/ListComponent';
import { useHistory, useLocation } from 'react-router-dom/cjs/react-router-dom.min';
import Icons from '../../assets/icons';
import { getPermissionKey } from '../../helper/permissions';
import GenericSpinnerLoader from '../../loaders/GenericSpinnerLoader';
import { getMenuMode, modifyDataForDocumentViewerUrlInsertion } from '../../helper/helperTableFunctions';
import { getPayloadFromURLParams, setPayloadAsURLParams } from '../../helper/URLParamsHelper';
import NewNoDataFound from '../../genericComponents/NewNoDataFound';
import GenericTabsComponent from '../../genericComponents/GenericTabsComponent';
import { parseJwt } from '../../helper/genericFunction';
import moment from 'moment';
import { Radio } from 'antd';
import { FileText, Package, Calendar, Mail, User, Building, LogIn } from 'lucide-react';
import { useCheckRolesAndPermision } from '../../helper/apiHelperFunctions';
import { useAcessVendorPortal } from '../../helper/hooks/helperHook';
import LanguageTranslator from '../../locals/LanguageTranslator';
import GenericCustomButton from '../../genericComponents/GenericCustomButton';

const GlobalSearchModal = (props = {}) => {

    let { userDetails } = props || {};
    const vendorPagePermission = useCheckRolesAndPermision(getPermissionKey("masterData", "vendors", "view"))
    const accessVendorPortal = useAcessVendorPortal();

    const history = useHistory();
    const location = useLocation();
    let uType = parseJwt(sessionStorage.getItem("token"))?.uType;

    const [loading, setLoading] = useState(false);
    const [currentTab, setCurrentTab] = useState('page')
    const [initialSearch, setInitialSearch] = useState('')

    const handleChange = (type, data) => {
        switch (type) {
            case "goToPage": {
                let temp = {
                    pathname: data?.pageUrl?.replace("#", "")
                };
                if (data?.pageUrl) {
                    history?.push(temp)
                }
                props.closeModal?.();
                break;
            }
            case "openDocumentViewer": {
                let obj = modifyDataForDocumentViewerUrlInsertion("encode", {
                    documentId: data?.id,
                    documentNo: data?.orderNumber,
                    documentType: getDocumentKey().documentType,
                });
                setPayloadAsURLParams({
                    data: {
                        ...getPayloadFromURLParams({
                            l: location,
                        }),
                        documentViewerConfig: obj,
                    },
                    // newPathName: getDocumentKey().path,
                    l: location,
                    h: history,
                })
                props.closeModal?.();
                break;
            };
            case "accessVendorPortal" : {
                accessVendorPortal({
                    username : data?.slCode || "",
                })
                break;
            }
            case "viewVendorDetails": {

                props.closeModal?.();

                // Update the url search params here.
                setPayloadAsURLParams({
                    data: {
                        ...getPayloadFromURLParams({
                            l: location,
                        }),
                        vendorDetailsConfig: {
                            vendorCode: data?.slCode || "",
                            vendorName: data?.slName || "",
                        },
                    },
                    l: location,
                    h: history,
                });
                break;
            }
            default: {
                break;
            }
        }
    }

    const [initialSet, setInitialSet] = useState(true);

    useEffect(() => {
        if (loading) {
            setCurrentTab(initialSet ? props?.activeTab || loading : loading);
            setInitialSet(false);
            setLoading(false);
        }
    }, [loading])

    useEffect(() => {
        if(isModulePresent("order") || isModulePresent("digivendVendor") || isModulePresent("digivendRetailer")) {
            setCurrentTab("po");
            setLoading("po");
        }
    }, [])

    // Function : To check if the modules is present or not
    const isModulePresent = (type) => {
        if (getMenuMode?.() == "new" ?!userDetails?.mainMenu : !userDetails?.modules ) return false;
        let modules =  getMenuMode?.() == "new" ? JSON.parse(userDetails?.mainMenu)?.moduleList?.[0] || []  : JSON.parse(userDetails?.modules);
        let procModule = (getMenuMode?.() == "new" ? modules?.slice(0,1) : modules)?.find(module => module.code == "RDPMAIN");
        switch (type) {
            case "indent": {
                return getMenuMode?.() == "new" ? modules?.[0]?.subModules?.find(item => item?.code == "RDPPOMAIN")?.subModules?.some(item => item?.code == "RDPPIVIS") || false : procModule?.subModules?.some(val => val?.code == "RDPPIMAIN");
            }
            case "order": {
                return getMenuMode?.() == "new" ? modules?.[0]?.subModules?.find(item => item?.code == "RDPPOMAIN")?.subModules?.some(item => item?.code == "RDPPOVOS") || false : procModule?.subModules?.some(val => val?.code == "RDPPOMAIN");
            }
            case "digivendVendor": {
                return getMenuMode?.() == "new" ? modules?.some(item => item?.code == "DIGIVEND") : modules?.some(module => module.code == "VDVMAIN")
            }
            case "digivendRetailer": {
                return getMenuMode?.() == "new" ?  modules?.[0]?.subModules?.some(item => ["RDVQCMAIN", "RDVSHIPAPS","RDVLOGLRP"]?.includes(item?.code)) : modules?.some(module => module.code == "RDVMAIN")
            }
        }
    }

    // Function : To check 

    const renderTabs = (config) => {
        let obj = {};
        let tabsData = {};

        if (isModulePresent("order") || isModulePresent("digivendVendor") || isModulePresent("digivendRetailer")) {
            tabsData['po'] = "Purchase Order";
        }
        tabsData['page'] = "Pages Shortcut";
        

        if(vendorPagePermission && uType == "ENT"){
            tabsData["vendor"] = "Vendor"
        }

        console.log("tabsData", config?.allData)

        return (
            <div className='px-[15px] flex items-center justify-between gap-4'>
                {Object.keys(tabsData || {})?.length > 1 && <Radio.Group 
                    className='global-search-tabs text-fontBlack flex items-center' 
                    onChange={(val) => {
                        setCurrentTab(val?.target?.value);
                        setLoading(val?.target?.value);
                    }}
                    value={currentTab}
                >
                    {
                        Object.keys(tabsData || {})?.map(item => {
                            return <Radio.Button style={{fontFamily: 'poppins'}} value={item}><LanguageTranslator>{tabsData[item] || ""}</LanguageTranslator></Radio.Button>
                        })
                    }
                </Radio.Group>}
                <div className='px-[15px] py-3.5'><div className='bg-[#F3F3F3] w-fit px-2 py-1 rounded-full'><p className='mb-0 text-fontGrey text-xs font-medium'><LanguageTranslator>Total Number of Records</LanguageTranslator> : <span className='text-fontBlack'>{currentTab == "page" ? config?.listDataCount || 0 : currentTab == "vendor" ? config?.allData?.apiAllData?.resultedDataCount || 0 : config?.allData?.apiAllData?.totalRecord || 0}</span></p></div></div>
            </div>
        )

    }


    // Function : To get the document key
    const getDocumentKey = () => {
        switch (currentTab) {
            case "pi": return { document_no: "indent_no", document_id: "id", tableName: "pimain", path: "/purchase/purchaseIndentHistory", documentType: "PI" };
            case "po": return { document_no: "orderNumber", document_id: "id", tableName: "pomain", path: "/enterprise/purchaseOrder/pendingOrders", documentType: "PO" };
            default: return "document_no"
        }
    }


    // Function : To get the props for the list component
    const getPayloadForListComponent = () => {
        let payload = {
            animationType: "top",
            postitionProps: { top: '7px', left: '71px', position: "absolute", margin: 0, borderRadius: 3 },
            dimensions: { width: "50vw", height: "70vh", maxHeight: '580px', maxWidth: '730px' },
            removeTransformProperty: true,
            modalMainClass: "global-search-modal",
            search: {
                placeholder: "Search Supplymint",
                isSearchIconRequire: () => {
                    return (
                        <span className='msa-search-icon'><Icons.NewSearchIcon /></span>
                    )
                },
                // leftComponent: renderDocumentDropdownOpton,
            },
            initialSearch: initialSearch,
        };        
        switch (currentTab) {
            case "page": {
                payload = {
                    ...payload,
                    renderCustomItems: {
                        1: (config) => renderTabs(config)
                    },
                    customNoDataFound: () => <NewNoDataFound className='!min-h-[320px] flex items-center justify-center' secondaryText={"Please try searching again or check other tabs."} />,
                    search: {
                        placeholder: "Search Supplymint",
                        isSearchIconRequire: () => {
                            return (
                                <span className='msa-search-icon'><Icons.NewSearchIcon /></span>
                            )
                        },
                        customSearchFunction: (listState, listFunctions) => {
                            const { listData, currentSearch } = listState;
                            setInitialSearch(currentSearch);
                            return listData?.filter(item => item?.name.toLowerCase().includes(currentSearch?.toLowerCase()));
                        }
                    },
                    headerKeys: {
                        "pageSearch": {
                            value: "Page Search", // This can be a function also which can show the dynamic data
                            width: "50%" // This defines the width of the column
                        }
                    },
                    itemKeys: {
                        "pageSearch": [
                            (state, functions, data) => {
                                let { currentSearch } = state;
                                const parts = data?.["name"].split(new RegExp(`(${currentSearch})`, 'gi'));
                                return (
                                    <div className='global-search-custom-col-wrapper flex justify-between items-center gap-4'>
                                        <span className='global-search-custom-col flex text-[13px] text-fontSlateGrey font-semibold m-[0]'>
                                            {parts?.map((part, index) =>
                                                part.toLowerCase() === currentSearch?.toLowerCase() ? (
                                                    <span key={index} className=''>
                                                        {part?.toUpperCase()}
                                                    </span>
                                                ) : <span>
                                                    {part[0] == " " && <span>&nbsp;</span>}
                                                    {part?.toUpperCase()}
                                                </span>
                                            )}
                                        </span>
                                        <Icons.GlobalSearchArrowIcon className='shrink-0'/>
                                    </div>
                                );
                            },
                            // we can pass the function to show the pagePath
                            "pagePath",
                        ]
                    },

                    getListData: () => {
                        function parseSubModules(module) {
                            let pageData = [];
                            module?.subModules?.forEach(subModule => {
                                subModule.pagePath = module.pagePath + " > " + subModule.name;
                                if (subModule.isPage === 0 && subModule.subModules) {
                                    pageData = [...pageData, ...parseSubModules(subModule, pageData)]
                                }
                                else pageData.push(subModule);
                            });
                            return pageData || [];
                        }
                        let modules = getMenuMode?.() == "new" ? JSON.parse(userDetails?.mainMenu)?.moduleList?.[0] || [] : JSON.parse(userDetails?.modules || "[]");
                        let pageData = [];

                        (getMenuMode?.() == "new" ? modules?.slice(0,1) : modules)?.map(module => {
                            if(getMenuMode?.() == "new" ? module.isPage != 2 : true){
                                module.pagePath = module.name;
                                if ((getMenuMode?.() == "new" ? true : module.isPage === 0) && module.subModules) {
                                    pageData = [...pageData, ...parseSubModules(module, pageData)];
                                }
                            }
                        })

                        const filteredData = pageData?.filter((item) => initialSearch ? item?.name.toLowerCase().includes(initialSearch?.toLowerCase()) : true)

                        return filteredData;
                    },

                    submitHandler: (data) => {
                        handleChange("goToPage", data);
                    }
                }
                break;
            }
            case "pi":
            case "po": {
                payload = {
                    ...payload,
                    search: {
                        ...payload.search,
                        placeholder: `Search ${currentTab === 'pi' ? 'Purchase Indents' : 'Purchase Orders'}`
                    },
                    isDebounceAllowed: true,
                    customNoDataFound: () => <NewNoDataFound className='!min-h-[320px] flex items-center justify-center' secondaryText={"Please try searching again or check other tabs."} />,
                    getListData: (data) => data?.resource?.map(item => ({ "document_no": item?.[getDocumentKey().document_no], ...item })) || [],
                    renderCustomItems: {
                        1: (config) => renderTabs(config)
                    },
                    api: {
                        reduxState: "generalStore",
                        apiName: "getGlobalSearchOrders",
                        apiPayload: (params) => {
                            setInitialSearch(params?.currentSearch)
                            return {
                                "displayName": uType == "ENT" ? "ENT_GLOBAL_SEARCH" : "VENDOR_GLOBAL_SEARCH",
                                "type": 1,
                                "pageNo": params?.currentPage || 1,
                                "pageSize": 10,
                                "sortedBy": "",
                                "sortedIn": "",
                                "search":  params?.currentSearch || "",
                                "filter": {}
                            }
                        },
                        getMaxPage: (states, functions, response) => {
                            return Number(response?.maxPage || "");
                        },
                        apiExtraHeaders: getPermissionKey("common", "commonfunctionality", "view")
                    },
                    headerKeys: {
                        "document_no": {
                            value: "Document Number", // This can be a function also which can show the dynamic data
                            width: "100%" // This defines the width of the column
                        }
                    },
                    itemKeys: {
                        "document_no": [
                            (state, functions, data) => {
                                // Function : To get the tag for the order number columns
                                const getTag = (item) => {
                                    return (
                                        <>
                                            <div className="poStatus">
                                                {item?.poSetType === "NON-SET" ? (
                                                    <span className="partialTable setTag nonSetTag labelEvent">N</span>
                                                ) : (
                                                    <span className="partialTable setTag labelEvent">S</span>
                                                )}
                                                <div className="poStatusToolTip">
                                                    {item?.poSetType === "NON-SET" ? (
                                                        <div className="each-tag">
                                                            <span className="partialTable setTag nonSetTag labelEvent">
                                                                N
                                                            </span>
                                                            <LanguageTranslator tag="label">Non-set</LanguageTranslator>
                                                        </div>
                                                    ) : (
                                                        <div className="each-tag">
                                                            <span className="partialTable setTag labelEvent">S</span>
                                                            <LanguageTranslator tag="label">Set</LanguageTranslator>
                                                        </div>
                                                    )}
                                                </div>
                                            </div>
                                            {item?.asnHoldCheck == 1 && (
                                                <div className="asnHoldCheck">
                                                    <Icons.FilePlusIcon />
                                                    <LanguageTranslator tag="span" className="table-tooltip">
                                                        ASN on Hold
                                                    </LanguageTranslator>
                                                </div>
                                            )}
                                        </>
                                    );
                                };
                                return (
                                    <div className='flex items-center justify-between gap-4' onClick={() => handleChange("openDocumentViewer", data)}>
                                        <div>
                                            <LanguageTranslator tag='p' className='mb-0.5 text-[11px] text-[#525676]'>ERP Number</LanguageTranslator>
                                            <p className='text-sm font-semibold text-[#111D31]'>{data?.["document_no"] || "-"} {getTag(data)}</p>
                                        </div>
                                        <div><Icons.GlobalSearchArrowIcon className='redirectArrow'/></div>
                                    </div>
                                );
                            },
                            (state, functions, data) => {
                                return (
                                    <div className='max-w-[92%] grid grid-cols-[1fr_1fr_.75fr_.5fr_auto] items-start gap-7' onClick={() => handleChange("openDocumentViewer", data)}>
                                        <div className='flex items-start gap-1'>
                                            <div><FileText size={14} color='#525676' /></div>
                                            <div>
                                                <LanguageTranslator tag='p' className='mb-0.5 text-[11px] text-[#525676] xl:whitespace-nowrap'>Document Number</LanguageTranslator>
                                                <p className='mb-0 text-[11px] font-medium text-fontBlack'>{data?.["documentNumber"]}</p>
                                            </div>
                                        </div>
                                        <div className='flex items-start gap-1'>
                                            <div><Calendar size={14} color='#525676' /></div>
                                            <div>
                                                <LanguageTranslator tag='p' className='mb-0.5 text-[11px] text-[#525676] xl:whitespace-nowrap'>PO Validity</LanguageTranslator>
                                                <p className='mb-0 text-[11px] font-medium text-fontBlack'>{data?.["validFromDate"] ? moment(data?.["validFromDate"])?.format("DD MMM YYYY") : ""} - {data?.["validToDate"] ? moment(data?.["validToDate"])?.format("DD MMM YYYY") : ""}</p>
                                            </div>
                                        </div>
                                        <div className='flex items-start gap-1'>
                                            {/* <div><FileText size={14} color='#525676' /></div> */}
                                            <div><Icons.VendorIcon/></div>
                                            <div>
                                                <LanguageTranslator tag='p' className='mb-0.5 text-[11px] text-[#525676] xl:whitespace-nowrap'>Vendor Name</LanguageTranslator>
                                                <p className='mb-0 text-[11px] font-medium text-fontBlack'>{data?.["vendorName"] || "-"}</p>
                                            </div>
                                        </div>
                                        <div className='flex items-start gap-1'>
                                            <div><Package size={14} color='#525676' /></div>
                                            <div>
                                                <LanguageTranslator tag='p' className='mb-0.5 text-[11px] text-[#525676] xl:whitespace-nowrap'>PO Qty.</LanguageTranslator>
                                                <p className='mb-0 text-[11px] font-medium text-fontBlack'>{data?.["poQty"] || "-"}</p>
                                            </div>
                                        </div>
                                        <div className='flex items-start gap-1 justify-self-end'>
                                            <div><Icons.PoAmount/></div>
                                            <div>
                                                <LanguageTranslator tag='p' className='mb-0.5 text-[11px] text-[#525676] xl:whitespace-nowrap'>PO Amount</LanguageTranslator>
                                                <p className='mb-0 text-[11px] font-medium text-fontBlack'>{data?.["poAmount"] || "-"}</p>
                                            </div>
                                        </div>
                                    </div>
                                )
                            }
                        ]
                    },
                }
                break;
            }
            case "vendor" : {
                let uType = parseJwt(sessionStorage.getItem("token"))?.uType;
                payload = {
                    ...payload,
                    search: {
                        ...payload.search,
                        placeholder: `Search Vendor`
                    },
                    isDebounceAllowed: true,
                    customNoDataFound: () => <NewNoDataFound className='!min-h-[320px] flex items-center justify-center' secondaryText={"Please try searching again or check other tabs."} />,
                    getListData: (data) => data?.resource || [],
                    renderCustomItems: {
                        1: (config) => renderTabs(config)
                    },
                    api: {
                        reduxState: "generalStore",
                        apiName: "getTableComponentFifthList",
                        apiPayload: (params) => {
                            setInitialSearch(params?.currentSearch)
                            return {
                                "displayName": "MANAGE_VENDOR_ALL",
                                "type": 3,
                                "pageNo": params?.currentPage || 1,
                                "pageSize": 10,
                                "sortedBy": "",
                                "sortedIn": "",
                                "search":  params?.currentSearch || "",
                                "filter": {},
                                "apiUrl" : "/vendorportal/managevendor/find/all/vendor",
                            }
                        },
                        getMaxPage: (states, functions, response) => {
                            return Number(response?.maxPage || "");
                        },
                        apiExtraHeaders: getPermissionKey("masterData", "vendors", "view")
                    },
                    headerKeys: {
                        "slName": {
                            value: "Vendor Name", // This can be a function also which can show the dynamic data
                            width: "100%" // This defines the width of the column
                        }
                    },
                    itemKeys: {
                        "slName": [
                            (state, functions, data) => {
                                return (
                                    <div className='flex items-center justify-between gap-4' onClick={() => handleChange("viewVendorDetails", data)}>
                                        <div>
                                            <LanguageTranslator tag='p' className='mb-0.5 text-[11px] text-[#525676]'>Vendors Name</LanguageTranslator>
                                            <p className='text-sm font-semibold text-[#111D31]'>{data?.["slName"] || "-"}</p>
                                        </div>
                                    </div>
                                );
                            },
                            (state, functions, data) => {
                                return (
                                    <div className='grid grid-cols-[repeat(3,1fr)_100px] place-items-start gap-7 items-start max-w-full' onClick={() => handleChange("viewVendorDetails", data)}>
                                        <div className='flex items-start gap-1'>
                                            <div><User size={14} color='#525676' /></div>
                                            <div>
                                                <LanguageTranslator tag='p' className='mb-0.5 text-[11px] text-[#525676] xl:whitespace-nowrap'>Vendor Code</LanguageTranslator>
                                                <p className='mb-0 text-[11px] font-medium text-fontBlack'>{data?.["slCode"]}</p>
                                            </div>
                                        </div>
                                        <div className='flex items-start gap-1'>
                                            <div><Mail size={14} color='#525676' /></div>
                                            <div>
                                                <LanguageTranslator tag='p' className='mb-0.5 text-[11px] text-[#525676] xl:whitespace-nowrap'>Email</LanguageTranslator>
                                                <p className='mb-0 text-[11px] font-medium text-fontBlack'>{data?.["email"] || ""}</p>
                                            </div>
                                        </div>
                                        <div className='flex items-start gap-1'>
                                            {/* <div><FileText size={14} color='#525676' /></div> */}
                                            <div><Building  size={14} color='#525676'/></div>
                                            <div>
                                                <LanguageTranslator tag='p' className='mb-0.5 text-[11px] text-[#525676] xl:whitespace-nowrap'>GST Number</LanguageTranslator>
                                                <p className='mb-0 text-[11px] font-medium text-fontBlack'>{data?.["shippedGSTNumber"] || "-"}</p>
                                            </div>
                                        </div>
                                        <div className='flex items-center cursor-pointer pr-5 justify-self-end'>
                                            <GenericCustomButton 
                                                type="link"
                                                onClick={(e) => {
                                                    e.stopPropagation();
                                                    handleChange("accessVendorPortal", data);
                                                }} 
                                                className='whitespace-nowrap' 
                                                leftIcon={<LogIn size={16} className='text-[#5d5fef] mr-[6px]' />} 
                                                label="Sign In" 
                                                size="medium"
                                            />
                                        </div>
                                    </div>
                                )
                            }
                        ]
                    },
                }
                break;
            }
            default: { }
        }

        return payload;
    }

    const renderListComponent = () => {
        switch (currentTab) {
            case "page": return <ListComponent  {...getPayloadForListComponent()} />
            case "po": return <ListComponent {...getPayloadForListComponent()} />
            case "pi": return <ListComponent {...getPayloadForListComponent()} />
            case "vendor" : return <ListComponent {...getPayloadForListComponent()} />
        }
    }

    return (
        <React.Fragment>
            {loading ? <div className='h-full w-full flex items-center justify-center'><GenericSpinnerLoader /></div> : renderListComponent()}
        </React.Fragment>
    )
}

export default GlobalSearchModal
